export default __webpack_public_path__ + "static/media/4.ec5469ab.png";